export const CLOUD_CONNECTION_OPEN = '@@connection/cloud/open'
export const CLOUD_CONNECTION_CLOSE = '@@connection/local/close'
export const LOCAL_CONNECTION_OPEN = '@@connection/local/open'
export const LOCAL_CONNECTION_CLOSE = '@@connection/local/close'
export const SWITCH_CONNECTION_TYPE = '@@connection/switch'
export const SAVE_TOKEN = '@@connection/token'
export const SAVE_TOKEN_EXPIRE_TIME = '@@connection/tokenExpireTime'
export const RESET_CONNECTION = '@@connection/reset'
